"use strict";

exports.__esModule = true;
exports.Hover = void 0;

var _basic = require("./basic.js");

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _defaults(subClass, superClass); }

/**
 * Enter animation on icon hover.
 */
var Hover = /*#__PURE__*/function (_Basic) {
  _inheritsLoose(Hover, _Basic);

  function Hover() {
    return _Basic.apply(this, arguments) || this;
  }

  var _proto = Hover.prototype;

  _proto.connectedCallback = function connectedCallback() {
    _Basic.prototype.connectedCallback.call(this);

    this.target.addEventListener('mouseenter', this.enterBound);
  };

  _proto.disconnectedCallback = function disconnectedCallback() {
    this.target.removeEventListener('mouseenter', this.enterBound);

    _Basic.prototype.disconnectedCallback.call(this);
  };

  _proto.enter = function enter() {
    if (!this.inAnimation) {
      this.playFromBegining();
    }
  };

  return Hover;
}(_basic.Basic);

exports.Hover = Hover;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hbmltYXRpb25zL2hvdmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUE7Ozs7OztBQUVBOzs7SUFHYSxLOzs7Ozs7Ozs7U0FDVCxpQixHQUFBLDZCQUFpQjtBQUNiLHFCQUFNLGlCQUFOOztBQUVBLFNBQUssTUFBTCxDQUFZLGdCQUFaLENBQTZCLFlBQTdCLEVBQTJDLEtBQUssVUFBaEQ7QUFDSCxHOztTQUVELG9CLEdBQUEsZ0NBQW9CO0FBQ2hCLFNBQUssTUFBTCxDQUFZLG1CQUFaLENBQWdDLFlBQWhDLEVBQThDLEtBQUssVUFBbkQ7O0FBRUEscUJBQU0sb0JBQU47QUFDSCxHOztTQUVELEssR0FBQSxpQkFBSztBQUNELFFBQUksQ0FBQyxLQUFLLFdBQVYsRUFBdUI7QUFDbkIsV0FBSyxnQkFBTDtBQUNIO0FBQ0osRzs7O0VBakJzQixZIiwic291cmNlUm9vdCI6IiJ9